export const BOOKLEADED = "books/loaded";
export const BOOKADD = "books/add";
export const DELETEBOOK = "books/delete";
export const EDIT = "books/edit";
